// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-D6R31","title":"title-hFrbN","service":"service-3xk20"};